import React from "react";
import { Link } from "react-router-dom";
import { RoughNotation } from "react-rough-notation";
import { Fade } from "react-awesome-reveal";

export default function Taglinedomain() {
  return (
    <div>
      <div className="container-fluid main">
        <div className="row">
          <div className="col-sm-8 ">
            <h1 className="head">
              <span className="headcolor">Hi there.</span> I’m{" "}
              <RoughNotation
                type="box"
                show="true"
                color="#e85a71"
                strokeWidth={2}
                padding={2}
              >
                Anshul,
              </RoughNotation>{" "}
              a Graphic Designer and Frontend Developer.
            </h1>
            <br />
            <h5>A Designer who likes to build interactive things with code.</h5>
            <br />

            <Fade direction="down" duration={2000}>
              <Link to="/about" className="btn-available">
                <i className="ri-sparkling-line iconf"></i>{" "}
                <span className="fw-bold text-capitalize">
                  Available for New Project
                </span>
              </Link>
            </Fade>
            <br />
            <h5 className="hoverclass">
              be a part of my network
              <i class="ri-ghost-smile-line"></i>
            </h5>
          </div>
          <div className="col-sm-4"></div>
        </div>
      </div>
    </div>
  );
}
